<template>
  <div class="paying-wrap">
    <p class="paying-tips">{{$t('tip.in30Minutes')}}</p>
    <div class="paytype-select-box">
      <!-- <h3 class="pay-title">{{选择支付方式'}}</h3> -->
      <p class="pay-label">
        <span class="flag">{{$t('text.orderNo')}}</span>
        <span>{{orderNo}}</span>
      </p>
      <p class="pay-label">
        <span class="flag">{{$t('text.restaurantName')}}</span>
        <span>{{storeName}}</span>
      </p>
      <p class="pay-label">
        <span class="flag">{{$t('text.deliveryLocation')}}</span>
        <span>{{sendType==2?storeAddress:address}}</span>
      </p>
      <p class="pay-label">
        <span class="flag">{{$t('text.contactNb')}}</span>
        <span>{{phone}}</span>
      </p>
      <p class="pay-label">
        <span class="flag">{{$t('text.totalAmount')}}</span>
        <span class="price">{{'￥' + totalPrice}}</span>
      </p>
      <p class="pay-tool-txt">{{$t('text.select[0]')}} {{$t('tip.payment')}}</p>
      <div class="pay-types">
        <button v-if="~payTypes.indexOf(1)"
          @click="payType=1"
          :class="{actived:payType==1}"
          class="pay-type__btn alipay__btn">
            <i class="select-checked" v-show="payType === 1"/>
          </button>
          <!-- <img :src="require('@/assets/image/icon/bg-alipay.png')"/> -->
<!--         <button v-if="~payTypes.indexOf(2)"
          @click="payType=2"
          :class="{actived:payType==2}"
          class="pay-type__btn alipay__btn"></button> -->
      </div>
      <div class="pay-submit-box">
        <Button @click.native="submit" class="cd-btn" sub>{{$t('text.confirmPay')}}</Button>
      </div>

    </div>

    <!-- <confirm-pay v-if="modal.show" @close="close" :type="modal.template" :data="modal.data"></confirm-pay> -->
  </div>
</template>
<script>
// import * as Com from 'project/common';
// import confirmPay from './modal-confirm-pay';
// import { BASEKEY } from '@/config';

export default {
  name: 'paying',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const self = vm;
      self.orderId = to.params.orderId;
      self.getOrder(self.orderId);
    });
  },
  data() {
    return {
      isLoading: false,
      storeId: 0,
      orderId: 0,
      orderNo: '',
      storeName: '',
      address: '',
      storeAddress: '',
      sendType: 0,
      phone: '',
      totalPrice: 0,
      payTypes: [],
      payType: 1,
      modal: {
        show: false,
        template: '',
        data: '',
      },
    };
  },
  methods: {
    getStore({ storeId, coordinate = [0, 0] }) {
      this.isLoading = true;
      this.$service.store.info({ content: { storeId, coordinate } })
        .then((result) => {
          this.isLoading = false;
          this.payTypes = [...result.data.onLinePayType];
          if (result.data.onLinePayType.indexOf(1) !== -1) { // 支付宝
            this.payType = 1;
          } else if (result.data.onLinePayType.indexOf(2) !== -1) { // 微信
            this.payType = 2;
          }
        })
        .catch(Function.prototype);
    },
    getOrder(orderId) {
      this.isLoading = true;
      this.$service.order.getter({ content: { orderId } })
        .then((result) => {
          if (result.data.orderStatus !== 1) {
            this.$Modal.alert({
              content: this.$t('orders.failure'),
              onOk() {
                this.$router.push({ path: '/user-center/order' });
                // let href = `${window.location.origin}/userCenter.html${BASEKEY}#/orders`;
                // window.location.href = href;
              },
            });
            return false;
          }
          this.getStore({
            storeId: result.data.storeId,
            coordinate: [result.data.longitude, result.data.latitude],
          });
          this.isLoading = false;
          for (const key in result.data) {
            if (Object.prototype.hasOwnProperty.call(this, key)) {
              this[key] = result.data[key];
            }
          }
          return true;
        })
        .catch(Function.prototype);
    },
    submit() {
      // let payType = 1;
      // if (this.payType === 2) {
      //   payType = 8;
      // }

      // 叫板比萨 天财支付
      // if (this.payType === 3 && Com.projectName == 'jiaobanbisa') {
      //   this.modal = {
      //     show: true,
      //     template: 'MembersPay',
      //     data: this.orderId
      //   }
      //   return;
      // }
      this.$service.order.pay({
        content: {
          orderId: this.orderId,
          payType: this.payType,
          returnUrl: `${window.location.origin}/#//user-center/order`,
        },
      })
        .then((result) => {
          // 叫板比萨需求
          // if (Com.projectName == 'jiaobanbisa') {
          //   if (this.payType === 1) {  // 支付宝支付
          //     window.open(result.data.url);
          //   } else if (this.payType === 2) {  // 微信支付
          //     if (result.data && result.data.url) {
          //       this.modal = {
          //       show: true,
          //       template: 'Wechat',
          //       data: result.data && result.data.url
          //       }
          //     } else {
          //       this.$Modal.alert({content: 二维码生成失败'});
          //     }

          //   }
          //   return ;
          // }
          // this.modal.show = true;
          // this.modal.template = 'Confirm';
          if (result.status !== 1) {
            this.$Modal.info({ content: result.msg });
            return;
          }
          if (this.payType === 1) { // 支付宝支付
            window.open(result.data.url);
          } else if (this.payType === 2) { // 微信支付
            window.open(`/wechatPay.html?url=${escape(result.data.url)}`);
          }
        })
        .catch((err) => {
          this.$Modal.info({ content: err.msg });
        });
      // catch(Function.prototype);
    },
    // close() {
    //   this.modal = {
    //     show: false,
    //     template: '',
    //     data: '',
    //   };
    // },
  },
  // components: {
  //   confirmPay
  // },
};
</script>
<style lang="sass" scoped>
@import '../../assets/css/mixins'
.paying-wrap
  min-height: 20px
  margin: 10px auto
  height: 702px
  .paying-tips
    padding: 16px 0
    font-size: 23px
    text-align: center
    background-color: #f3f3f3
    color: #0e9675
  .paytype-select-box
    height: 609px
    padding-top: 28px
    margin: 20px auto
    background-color: #f3f3f3
    // .pay-title
    //   height: 50px
    //   line-height: 50px
    //   font-size: 16px
    //   font-weight: bold
    //   border-bottom: 1px solid #e0e0e0
    //   margin: 0px 6px 20px
    //   padding-left: 18px
    .pay-label
      font-size: 14px
      line-height: 39px
      color: #333
      > span
        display: inline-block
        vertical-align: top
        height: 28px
        line-height: 28px
      .flag
        font-size: 14px
        padding-left: 22px
        margin-right: 9px
      .price
        color: #0e9675
    .pay-tool-txt
      color: #0e9675
      font-size: 21px
      padding-left: 22px
    .pay-types
      font-size: 14px
      padding-left: 22px
      .pay-type__btn
        position: relative
        display: inline-block
        vertical-align: top
        width: 180px
        height: 80px
        line-height: 34px
        text-align: center
        background-color: #fff
        @include border-radius(3px)
        border: 1px solid #ece5e0
        margin: 15px 12px 29px 0
        padding: 0px 5px
        .select-checked
          background: url('../../assets/image/icon/icon-li-bg.png') no-repeat right top
          position: absolute
          display: inline-block
          top: 0
          right: 0
          width: 36px
          height: 37px
        &.alipay__btn
          background: url('../../assets/image/icon/bg-alipay.png') no-repeat
        &.actived, &:hover
          border-color: #0f9675
          color: #0f9675
    .pay-submit-box
      text-align: center
      font-size: 18px
      background-color: #f3f3f3
      color: #f99b1d
      margin-top: 56px
      // .cd-btn
      //   width: 118px
</style>
